module.exports = __webpack_public_path__ + "assets/e61d348ab0fcd0debe806f09b6f51ede.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_10.mp3
 ** module id = 46
 ** module chunks = 0
 **/